import { useEffect, useState } from 'react';

import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";

import { CustomStepperInterface } from '../../../Models/Common/CustomViewsInterfaces';

import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';

const StepperContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    display: flex;
    overflow: unset !important;

    .stepperItem {
        &:first-of-type{
            border-radius: 4px 0px 0px 0px !important;
        }

        &:last-of-type{
            border-radius: 0px 4px 0px 0px !important;
            &:after {
                border-color: transparent !important;

            }
        }
    }
`;

const StepContainer = styled(Card) <{ $darkMode?: boolean; $isSelected?: boolean; $disableStepperOnClick?: boolean; }>`
    // background: ${(props) => props.$isSelected ? (props.$darkMode ? '#1c2a30' : '#25a0e21a') : 'transparent'} !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    width: -webkit-fill-available;
    position: relative;
    overflow: unset !important;
    padding: 15px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${(props) => props.$disableStepperOnClick ? 'default' : 'pointer'} !important;

    .svgContainer {
        background: ${(props) => props.$darkMode ? '#222527' : '#def1fb'} !important;
        border-radius: 20px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            width: 20px;
            height: 20px;
            color: #25a0e2;
        }
    }

    .stepHeaderText {
        font-size: 15px !important;
        font-weight: 500 !important;
        margin: 0px 0px 0px 10px;
    }

    &:after {
        content: '';
        position: absolute;
        right: -10px; /* Adjust to control how far down the arrow appears */
        top: 32%;
        transform: translateX(0%); /* Center the arrow horizontally */
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 10px solid ${(props) => props.$isSelected ? (props.$darkMode ? '#1c2a30' : '#25a0e21a') : 'transparent'}; /* Arrow color matches div background */
        z-index: 1;

    }
`;


export default function CustomStepper(props: CustomStepperInterface) {
    let isDarkMode = LocalStorageHelper.isDarkMode();

    return <StepperContainer>
        {props?.stepperItems?.map((step: any) => (
            <StepContainer 
            sx={{backgroundColor: (props?.selectedStep?.id == step.id ? 'customBackground.stepperSelected' : 'customBackground.main')}}
            $darkMode={isDarkMode} 
            $disableStepperOnClick={props?.disableStepperOnClick ?? false}
            className="stepperItem" 
            $isSelected={props?.selectedStep?.id == step.id}
            onClick={() => {
                if(props?.onClickStep && !props?.disableStepperOnClick) {
                    props.onClickStep(step);
                }
            }} >
                <div className="svgContainer">{step?.icon ?? ""}</div>
                <Typography color={props?.selectedStep?.id == step.id ? 'selectedText' : 'primaryText'} className="stepHeaderText">{step?.name ?? ""}</Typography>
            </StepContainer>
        ))}
    </StepperContainer>
}
